const SvgRecorrido: React.FC<{ className?: string, height?: number, width?: number }> = ({ className, height = 24, width = 24 }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`h-6 w-8 bi bi-recorrido ${className} `}
        width={width}
        height={height}
        fill="none"
        stroke="currentColor"
        strokeWidth={1}
    >
        <path d="M3.5,19c1.379,0,2.5-1.121,2.5-2.5s-1.121-2.5-2.5-2.5-2.5,1.121-2.5,2.5,1.121,2.5,2.5,2.5Zm0-4c.827,0,1.5,.673,1.5,1.5s-.673,1.5-1.5,1.5-1.5-.673-1.5-1.5,.673-1.5,1.5-1.5Zm3.5,7.2v1.8h-1v-1.8c0-.662-.538-1.2-1.2-1.2H2.2c-.662,0-1.2,.538-1.2,1.2v1.8H0v-1.8c0-1.213,.987-2.2,2.2-2.2h2.6c1.213,0,2.2,.987,2.2,2.2ZM19,5.983l4.941-2.977L19.091,0h-1.091V10h1V5.983Zm0-4.863l3.023,1.874-3.023,1.821V1.12Zm5,17.38c0,1.93-1.57,3.5-3.5,3.5H9v-1h11.5c1.379,0,2.5-1.121,2.5-2.5s-1.121-2.5-2.5-2.5H12.5c-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5h3.5v1h-3.5c-1.379,0-2.5,1.122-2.5,2.5s1.121,2.5,2.5,2.5h8c1.93,0,3.5,1.57,3.5,3.5Z" />

    </svg>


);

export default SvgRecorrido;